import * as ua from "./ua"
import * as request from "./request"
import * as helper from "./helper"

export function dataReport(params, opts) {
  opts = opts || {}
  var pu = []
  params[6] = +new Date()
  params[7] = params[7] || 0
  for (var k in params) {
    pu.push(k + "=" + encodeURIComponent(params[k]))
  }

  var pu2 = []
  for (var o in opts) {
    pu2.push("&" + o + "=" + encodeURIComponent(opts[o]))
  }
  request
    .ajax({
      type: "post",
      url: "//szmg.qq.com/cgi-bin/log_data.fcg",
      data: {
        offer_id: "15499",
        num: 1,
        record0: pu.join("|")
      }
    })
    .catch(() => {})
}

export function speedReport(params) {
  let url = "//report.huatuo.qq.com/report.cgi",
    userAgent = ua.getUserAgent(),
    platform = "other",
    app = "other"
  if (userAgent.iOS) {
    platform = "ios"
  } else if (userAgent.android) {
    platform = "android"
  }

  if (userAgent.weixin) {
    app = "wechat"
  } else if (userAgent.QQ) {
    app = "mqq"
  }

  let data = {
    appid: "20138",
    platform: platform,
    app: app,
    speedparams: decodeURIComponent(
      request.serializeParams(
        helper.extend(
          {
            flag1: 21423,
            flag2: 1
          },
          params
        )
      )
    )
  }
  new Image().src = `${url}?${request.serializeParams(data)}`
}
